import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { Select2Module } from 'ng-select2-component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputGroupComponent } from './components/input-group/input-group.component';
import { SelectFieldComponent } from './components/select-field/select-field.component';
import { CheckboxFieldComponent } from './components/checkbox-field/checkbox-field.component';
import { CheckboxGroupComponent } from './components/checkbox-group/checkbox-group.component';
import { SelectGroupComponent } from './components/select-group/select-group.component';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { FormErrorDirective } from './directives/form-error.directive';
import { ErrorCodesService } from './interfaces/error-codes.service';
import { MockErrorCodesService } from './services/mock-error-codes.service';
import { TextFieldComponent } from './components/text-field/text-field.component';
import { TextGroupComponent } from './components/text-group/text-group.component';
import { InputFilterDirective } from './directives/input-filter.directive';
import { SelectTagsComponent } from './components/select-tags/select-tags.component';
import { SelectTagsGroupComponent } from './components/select-tags-group/select-tags-group.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormLabelTooltipDirective } from './directives/form-label-tooltip.directive';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { PasswordInfoComponent } from './components/password-info/password-info.component';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { CheckboxModule } from 'primeng/checkbox';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePickerModule } from 'primeng/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TextareaModule } from 'primeng/textarea';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Select2Module,
    NgSelectModule,
    NgbTooltipModule,
    SharedUiIconsModule,
    CheckboxModule,
    InputGroupModule,
    InputTextModule,
    PasswordModule,
    InputNumberModule,
    DatePickerModule,
    InputGroupAddonModule,
    MultiSelectModule,
    SelectModule,
    AutoCompleteModule,
    TextareaModule,
  ],
  declarations: [
    InputGroupComponent,
    SelectFieldComponent,
    CheckboxFieldComponent,
    CheckboxGroupComponent,
    SelectGroupComponent,
    FormErrorComponent,
    FormErrorDirective,
    TextFieldComponent,
    TextGroupComponent,
    InputFilterDirective,
    SelectTagsComponent,
    SelectTagsGroupComponent,
    FormLabelTooltipDirective,
    PhoneInputComponent,
    PasswordInfoComponent,
  ],
  exports: [
    InputGroupComponent,
    SelectFieldComponent,
    CheckboxFieldComponent,
    CheckboxGroupComponent,
    SelectGroupComponent,
    FormsModule,
    ReactiveFormsModule,
    FormErrorDirective,
    TextFieldComponent,
    TextGroupComponent,
    InputFilterDirective,
    SelectTagsComponent,
    SelectTagsGroupComponent,
    FormLabelTooltipDirective,
    PhoneInputComponent,
    PasswordInfoComponent,
  ],
  providers: [{ provide: ErrorCodesService, useClass: MockErrorCodesService }],
})
export class SharedUiInputsModule {}
